/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetInventoryTransactionResponse = {
    name?: string;
    sku?: string;
    type?: GetInventoryTransactionResponse.type;
    optionName1?: string;
    optionName2?: string;
    optionValue1?: string;
    optionValue2?: string;
    inputAmount?: number;
    oldAmount?: number;
    newAmount?: number;
    createdAt?: string;
    actionByFirstName?: string;
    actionByLastName?: string;
    imeis?: string;
    orderNo?: string;
};
export namespace GetInventoryTransactionResponse {
    export enum type {
        GENERAL = 'GENERAL',
        MOBILE = 'MOBILE',
    }
}

